(function() {
  document.addEventListener('DOMContentLoaded', function () {
    let userChangedVariant = false;

    document.addEventListener('change', function(event) {
      if (
        event.target.matches('input[name^="options"]') ||
        event.target.matches('select[name^="options"]')
      ) {
        userChangedVariant = true;
      }
    });

    function moveFrameImageFirst() {
      if (userChangedVariant) return;

      const mediaContainer = document.querySelector('[data-product-single-media-slider]');
      if (!mediaContainer) return;

      const mediaItems = mediaContainer.querySelectorAll('[data-product-single-media-wrapper]');
      if (!mediaItems.length) return;

      const frameItem = Array.from(mediaItems).find(item => {
        const img = item.querySelector('img');
        if (!img) return false;

        const alt = (img.getAttribute('alt') || '').toLowerCase();
        const src = (img.getAttribute('src') || '').toLowerCase();

        return alt.includes('marco') || src.includes('marco');
      });

      if (frameItem) {
        mediaContainer.prepend(frameItem);
      }
    }

    setTimeout(moveFrameImageFirst, 200);
    setTimeout(moveFrameImageFirst, 800);
    setTimeout(moveFrameImageFirst, 1500);
  });
})();